import { Component, Inject } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

/**
 * Generic confirmation dialog component
 * Used for actions that require user confirmation before proceeding
 */
@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  template: `
    <div class="confirm-dialog-container p-6">
      <h2 class="text-xl font-medium mb-4">{{ data.title || 'Bevestiging' }}</h2>

      <div class="message mb-6">
        <p>{{ data.message }}</p>
      </div>

      <div class="flex justify-end gap-3">
        <button mat-button type="button" (click)="close(false)">
          {{ data.cancelButtonText || 'Annuleren' }}
        </button>

        <button mat-flat-button class="dd-action-button" (click)="close(true)">
          {{ data.confirmButtonText || 'Bevestigen' }}
        </button>
      </div>
    </div>
  `,
})
export class ConfirmDialogComponent {
  /**
   * @param dialogRef Reference to the dialog
   * @param data Dialog data containing the following properties:
   *   - title: Dialog title (optional, defaults to 'Bevestiging')
   *   - message: Message to display (required)
   *   - confirmButtonText: Text for the confirm button (optional, defaults to 'Bevestigen')
   *   - cancelButtonText: Text for the cancel button (optional, defaults to 'Annuleren')
   */
  constructor(
    private dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title?: string;
      message: string;
      confirmButtonText?: string;
      cancelButtonText?: string;
    }
  ) {}

  /**
   * Close the dialog with result
   * @param result True if confirmed, false if cancelled
   */
  close(result: boolean): void {
    this.dialogRef.close(result);
  }
}
